module.exports = __webpack_public_path__ + "04_bob_gold.37ddd066.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/04_bob_gold.png
// module id = fiwy
// module chunks = 0